/** QuickRouter — Couches cuivre d'une carte 2, 4 ou 6 couches.
 *
 * Noms : F (dessus), In1…In4 (internes, de haut en bas), B (dessous). Une carte 2 couches
 * n'a que F et B : tous les projets antérieurs restent valides tels quels.
 * Rôle d'une couche : « signal » (pistes) ou « plan » (zone pleine GND / alimentation, pas de
 * piste du routeur automatique). Les traversants et les vias traversants touchent TOUTES les
 * couches ; un CMS est sur F ou B.
 */

export const ALL_CU = ['F', 'In1', 'In2', 'In3', 'In4', 'B'];

const STACK = {
  2: ['F', 'B'],
  4: ['F', 'In1', 'In2', 'B'],
  6: ['F', 'In1', 'In2', 'In3', 'In4', 'B'],
};

/** Rôles par défaut : 4 couches = signal / GND / alim / signal ; 6 couches = signal / GND /
 *  signal / alim / GND / signal (empilage conseillé pour l'USB 3.0 et le Gigabit). */
const DEFAULT_ROLES = {
  2: {},
  4: { In1: 'plane', In2: 'plane' },
  6: { In1: 'plane', In2: 'signal', In3: 'plane', In4: 'plane' },
};

export const LAYER_COLORS = {
  F: '#d23b3b', In1: '#c8b400', In2: '#3fae62', In3: '#e08a1e', In4: '#9b59d0', B: '#3d7be0',
};

export const LAYER_LABELS = {
  F: 'Dessus (F)', In1: 'Interne 1', In2: 'Interne 2', In3: 'Interne 3', In4: 'Interne 4', B: 'Dessous (B)',
};

/** Couches cuivre de la carte, de haut en bas. */
export function copperLayers(board) {
  return STACK[board?.layers ?? 2] ?? STACK[2];
}

export const isOuter = (L) => L === 'F' || L === 'B';

export function layerRole(board, L) {
  if (isOuter(L)) return 'signal';
  return board?.roles?.[L] ?? DEFAULT_ROLES[board?.layers ?? 2]?.[L] ?? 'signal';
}

/** Couches où l'on route des pistes (rôle signal). */
export function routableLayers(board) {
  return copperLayers(board).filter((L) => layerRole(board, L) === 'signal');
}

/** Position 1…n de la couche dans l'empilage (numérotation Gerber L1…Ln). */
export function layerNumber(board, L) {
  return copperLayers(board).indexOf(L) + 1;
}

/** Couche existante sur cette carte ? */
export const hasLayer = (board, L) => copperLayers(board).includes(L);

/** Couches d'une pastille : traversante métallisée = toutes ; CMS = sa face ; NPTH = aucune. */
export function padCopper(pad, board) {
  if (pad.drill) return pad.plated === false ? [] : copperLayers(board);
  return pad.layers;
}
